/* ============================================================
   S4 — EP player + scroll reveals
   Self-contained. No dependencies.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- helpers ---------- */

  function fmt(sec) {
    if (!isFinite(sec) || sec < 0) sec = 0;
    var m = Math.floor(sec / 60);
    var s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  /* ---------- player ---------- */

  function initPlayer(root) {
    if (root.dataset.s4Init === '1') return;
    root.dataset.s4Init = '1';

    var audio    = root.querySelector('[data-s4-audio]');
    var trackEls = Array.prototype.slice.call(root.querySelectorAll('[data-s4-track]'));
    var panel    = root.querySelector('[data-s4-panel]');
    var playBtn  = root.querySelector('[data-s4-play]');
    var prevBtn  = root.querySelector('[data-s4-prev]');
    var nextBtn  = root.querySelector('[data-s4-next]');
    var titleEl  = root.querySelector('[data-s4-title]');
    var curEl    = root.querySelector('[data-s4-current]');
    var durEl    = root.querySelector('[data-s4-duration]');
    var scrub    = root.querySelector('[data-s4-scrub]');
    var fill     = root.querySelector('[data-s4-fill]');
    var head     = root.querySelector('[data-s4-head]');

    if (!audio || !trackEls.length) return;

    var index = -1;

    /* Preload durations so the track list shows real times before playback */
    trackEls.forEach(function (el) {
      var src = el.getAttribute('data-src');
      var out = el.querySelector('[data-s4-tracktime]');
      if (!src || !out || out.textContent.trim()) return;
      var probe = new Audio();
      probe.preload = 'metadata';
      probe.addEventListener('loadedmetadata', function () {
        // Leave it blank rather than showing a bogus 0:00 when the server
        // doesn't report a length the browser can turn into a duration.
        if (isFinite(probe.duration) && probe.duration > 0) {
          out.textContent = fmt(probe.duration);
        }
      });
      probe.src = src;
    });

    function paint() {
      trackEls.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
        el.classList.toggle('is-playing', i === index && !audio.paused);
        el.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (panel) panel.classList.toggle('is-playing', !audio.paused && index > -1);
      if (playBtn) {
        playBtn.setAttribute('aria-label', audio.paused ? 'Play' : 'Pause');
      }
    }

    function load(i, autoplay) {
      if (i < 0 || i >= trackEls.length) return;
      index = i;
      var el = trackEls[i];
      audio.src = el.getAttribute('data-src');
      if (titleEl) titleEl.textContent = el.getAttribute('data-title') || '';
      if (curEl) curEl.textContent = '0:00';
      if (durEl) durEl.textContent = '0:00';
      if (fill) fill.style.width = '0%';
      if (head) head.style.left = '0%';
      paint();
      if (autoplay) {
        var p = audio.play();
        if (p && p.catch) p.catch(function () { /* autoplay blocked — user will tap */ });
      }
    }

    function toggle() {
      if (index === -1) { load(0, true); return; }
      if (audio.paused) audio.play(); else audio.pause();
    }

    /* Track rows */
    trackEls.forEach(function (el, i) {
      el.addEventListener('click', function () {
        if (i === index) { toggle(); } else { load(i, true); }
      });
    });

    if (playBtn) playBtn.addEventListener('click', toggle);
    if (nextBtn) nextBtn.addEventListener('click', function () {
      load((index + 1) % trackEls.length, true);
    });
    if (prevBtn) prevBtn.addEventListener('click', function () {
      // Restart current track if we're more than 3s in, else go back one
      if (index > -1 && audio.currentTime > 3) { audio.currentTime = 0; return; }
      load((index - 1 + trackEls.length) % trackEls.length, true);
    });

    audio.addEventListener('play',  paint);
    audio.addEventListener('pause', paint);
    audio.addEventListener('ended', function () {
      if (index < trackEls.length - 1) load(index + 1, true);
      else { index = -1; paint(); }
    });

    audio.addEventListener('loadedmetadata', function () {
      if (durEl) durEl.textContent = fmt(audio.duration);
    });

    audio.addEventListener('timeupdate', function () {
      if (!audio.duration) return;
      var pct = (audio.currentTime / audio.duration) * 100;
      if (fill) fill.style.width = pct + '%';
      if (head) head.style.left = pct + '%';
      if (curEl) curEl.textContent = fmt(audio.currentTime);
      if (scrub) {
        scrub.setAttribute('aria-valuenow', Math.round(pct));
        scrub.setAttribute('aria-valuetext', fmt(audio.currentTime) + ' of ' + fmt(audio.duration));
      }
    });

    /* Scrubbing */
    if (scrub) {
      var seeking = false;

      function seekFrom(clientX) {
        var r = scrub.getBoundingClientRect();
        var pct = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
        if (audio.duration) audio.currentTime = pct * audio.duration;
        if (fill) fill.style.width = pct * 100 + '%';
        if (head) head.style.left = pct * 100 + '%';
      }

      scrub.addEventListener('pointerdown', function (e) {
        if (index === -1) load(0, true);
        seeking = true;
        scrub.setPointerCapture(e.pointerId);
        seekFrom(e.clientX);
      });
      scrub.addEventListener('pointermove', function (e) {
        if (seeking) seekFrom(e.clientX);
      });
      scrub.addEventListener('pointerup', function (e) {
        seeking = false;
        try { scrub.releasePointerCapture(e.pointerId); } catch (err) {}
      });

      /* Keyboard seeking */
      scrub.addEventListener('keydown', function (e) {
        if (!audio.duration) return;
        var step = audio.duration / 20;
        if (e.key === 'ArrowRight') { audio.currentTime = Math.min(audio.duration, audio.currentTime + step); e.preventDefault(); }
        if (e.key === 'ArrowLeft')  { audio.currentTime = Math.max(0, audio.currentTime - step); e.preventDefault(); }
      });
    }

    /* Only one S4 player audible at a time on a page */
    audio.addEventListener('play', function () {
      document.querySelectorAll('[data-s4-audio]').forEach(function (other) {
        if (other !== audio && !other.paused) other.pause();
      });
    });
  }

  /* ---------- scroll reveal ---------- */

  function initReveals(scope) {
    var els = (scope || document).querySelectorAll('.s4-reveal:not([data-revealed])');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    els.forEach(function (el) {
      el.setAttribute('data-revealed', '1');
      io.observe(el);
    });
  }

  /* ---------- marquee: duplicate track for seamless loop ---------- */

  function initMarquee(scope) {
    (scope || document).querySelectorAll('[data-s4-marquee]:not([data-dup])').forEach(function (track) {
      track.setAttribute('data-dup', '1');
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* ---------- boot ---------- */

  function boot(scope) {
    (scope || document).querySelectorAll('[data-s4-player]').forEach(initPlayer);
    initMarquee(scope);
    initReveals(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* Re-init inside the theme editor when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
